import { inject, InjectionToken } from '@angular/core';
import { AuthClientService } from '../services';
import { Auth } from '@angular/fire/auth';
import { Observable } from 'rxjs';

export const AUTH_CLIENT_TOKEN: InjectionToken<AuthClientProvider> = new InjectionToken<AuthClientProvider>(
  'AUTH_CLIENT_TOKEN',
  {
    factory: (): AuthClientProvider => {
      const authClientService: AuthClientService = inject(AuthClientService);

      return {
        get authClient(): Auth {
          return authClientService.authClient;
        },

        get isAuthed$(): Observable<boolean> {
          return authClientService.isAuthed$;
        }
      };
    }
  }
);

export interface AuthClientProvider {
  get authClient(): Auth;
  get isAuthed$(): Observable<boolean>;
}
